import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DSCRLoansPage = lazy(() => import('../pages/dscr-loans/page'));
const DSCRLoanRequirementsPage = lazy(() => import('../pages/dscr-loan-requirements/page'));
const BestDSCRLendersPage = lazy(() => import('../pages/best-dscr-lenders/page'));
const DSCRLoanRatesPage = lazy(() => import('../pages/dscr-loan-rates/page'));
const TypesOfDSCRLoansPage = lazy(() => import('../pages/types-of-dscr-loans/page'));
const DSCRLoanBenefitsPage = lazy(() => import('../pages/dscr-loan-benefits/page'));
const DSCRLoanBasicsPage = lazy(() => import('../pages/dscr-loan-basics/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/dscr-loans',
    element: <DSCRLoansPage />,
  },
  {
    path: '/dscr-loan-requirements',
    element: <DSCRLoanRequirementsPage />,
  },
  {
    path: '/best-dscr-lenders',
    element: <BestDSCRLendersPage />,
  },
  {
    path: '/dscr-loan-rates',
    element: <DSCRLoanRatesPage />,
  },
  {
    path: '/types-of-dscr-loans',
    element: <TypesOfDSCRLoansPage />,
  },
  {
    path: '/dscr-loan-benefits',
    element: <DSCRLoanBenefitsPage />,
  },
  {
    path: '/dscr-loan-basics',
    element: <DSCRLoanBasicsPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
